import React from 'react'
import {
  FormGroup,
  Col,
  InputGroup,
  InputGroupAddon,
  Button,
  Input,
} from 'reactstrap'

/*

  <SetsAdd 
    addSetName={props.addSetName} 
    handleAddSetNameChange={props.handleAddSetNameChange} 
    handleSubmitAddSet={props.handleSubmitAddSet}  
  />

*/

export default function SetsAdd(props) {
  
  function handleEnterToAddSet(e) {
    if (e.key === 'Enter' && props.addSetName) {
      props.handleSubmitAddSet()
    }
  }
  
  return (
    <FormGroup row>
      <Col md="12">
        <InputGroup>
          <InputGroupAddon addonType='prepend'>
            <Button 
              disabled={props.addSetName ? false : true} 
              color="success"
              onClick={() => props.handleSubmitAddSet()}
            ><i className="fa fa-plus"></i> Add Set</Button>
          </InputGroupAddon>
          <Input 
            type="text" 
            id="addSet" 
            name="addSet" 
            placeholder="Add a set"
            value={props.addSetName}
            onChange={(e) => props.handleAddSetNameChange(e)}
            onKeyPress={(e) => handleEnterToAddSet(e)}
          />
        </InputGroup>
      </Col>
    </FormGroup>
  )
}






/*

    <FormGroup row>
      <Col md="12">
        <InputGroup>
          <InputGroupAddon addonType='prepend'>
            <Button disabled color="secondary"><i className="fa fa-search"></i> Search</Button>
          </InputGroupAddon>
          <Input 
            type="text" 
            id="search" 
            name="search" 
            placeholder="Search for a set"
            value={props.setSearch}
            onChange={(e) => props.handleSetSearchChange(e)}
          />
        </InputGroup>
      </Col>
    </FormGroup>

*/


// WEBPACK FOOTER //
// ./src/components/Content/ManageSetsComponents/SetsAdd.js